import React from 'react'
import { MAIN_PHONE_NUMBER, MAIN_PHONE_NUMBER_LINK } from '@constants/index'
import PhoneSvg from '@shared/svg/phone.svg'

import styles from './style.module.scss'

export const Phone = () => (
	<a href={`tel:${MAIN_PHONE_NUMBER_LINK}`}>
		<div className={styles.full}>
			<span className={styles.phone}>{MAIN_PHONE_NUMBER}</span>
		</div>
		<div className={styles.mobile}>
			<a href={`tel:${MAIN_PHONE_NUMBER_LINK}`}>
				<PhoneSvg className={styles.mobilePhone} />
			</a>
		</div>
	</a>
)
